<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.INVOICES.INDEX"
        :label="translations.invoicesNavigation"
        :should-show-label
      />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/constants/routes'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './Invoices.translations'

const i18n = useI18n()

const { isFeatureEnabled } = useBusinessFeaturesStore()

function shouldShowLabel(routeName: string): boolean {
  if (routeName === ROUTE_NAMES.INVOICES.FINANCIAL_REPORT)
    return isFeatureEnabled('financeReportEnabled')

  return true
}
</script>
